import Image from "next/image";
import styles from "./AboutCard.module.css";

const AboutCard = ({ about }) => (
  <div className={`grid w-[255px] lg:w-[349px] h-full rounded-lg shadow-lg ${styles.layout}`}>
    <div className="relative">
      <Image src="/become-consultant/about-card-bg.png" alt="Background" layout="fill" />
      <div className="flex relative flex-col px-5 pt-5 pb-3 h-full">
        <div className="relative h-[110px] lg:h-[220px]">
          <Image
            src={`${process.env.NEXT_PUBLIC_STORAGE_URL}/content/${about.picture}`}
            alt={about.title}
            objectFit="cover"
            layout="fill"
            className="absolute rounded-t-lg"
          />
        </div>
        <h3 className="mt-3 lg:text-xl font-semibold text-center text-grey-900">{about.title}</h3>
      </div>
    </div>
    <p className="px-5 pt-6 pb-6 text-sm text-grey-700">{about.text}</p>
  </div>
);

export default AboutCard;
